/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNames, tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('md-content')
@classNames('md-default-theme', 'layout-row', 'badge-list')
export default class BadgeList extends Component {
  linkImage = true;
  allowProfileUploads = false;
}
